import { useState, useEffect } from 'react';

type GuideRecord = Record<string, boolean>;

interface UserGuideManager {
  isFirstVisit: boolean;
  addFeature: (featureKey: string) => void;
  checkFeature: (featureKey: string) => boolean;
  completeGuide: (featureKey: string) => void;
  resetAllGuides: () => void;
}

const useUserGuideManager = (): UserGuideManager => {
  const STORAGE_KEY = 'userGuides';

  const [isFirstVisit, setIsFirstVisit] = useState<boolean>(false);

  const initializeStorage = (): GuideRecord => {
    const guides = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') as GuideRecord;
    if (!localStorage.getItem(STORAGE_KEY)) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(guides));
    }
    return guides;
  };

  useEffect(() => {
    initializeStorage();
  }, []);

  const addFeature = (featureKey: string): void => {
    const guides = initializeStorage();
    if (!guides[featureKey]) {
      guides[featureKey] = false;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(guides));
    }
  };

  const checkFeature = (featureKey: string): boolean => {
    const guides = initializeStorage();
    return featureKey in guides;
  };

  const completeGuide = (featureKey: string): void => {
    const guides = initializeStorage();
    if (guides[featureKey] === false) {
      guides[featureKey] = true;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(guides));
      setIsFirstVisit(false);
    }
  };

  const resetAllGuides = (): void => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({}));
    setIsFirstVisit(false);
  };

  return { isFirstVisit, addFeature, checkFeature, completeGuide, resetAllGuides };
};

export default useUserGuideManager;
